import { render, staticRenderFns } from "./MNavigationDrawer.vue?vue&type=template&id=3f923588&scoped=true"
import script from "./MNavigationDrawer.vue?vue&type=script&lang=ts"
export * from "./MNavigationDrawer.vue?vue&type=script&lang=ts"
import style0 from "./MNavigationDrawer.vue?vue&type=style&index=0&id=3f923588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f923588",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MAppAccount: require('/codebuild/output/src3348358703/src/app/components/molecules/MAppAccount.vue').default,AMenuItem: require('/codebuild/output/src3348358703/src/app/components/atoms/Menu/AMenuItem.vue').default,AMenuSubItem: require('/codebuild/output/src3348358703/src/app/components/atoms/Menu/AMenuSubItem.vue').default})
